// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._3IlFEbyxwjKJ9Sy-1JAUwL {\n    margin: 0;\n    padding: 0 8px;\n    color: white;\n  }\n  ._3IlFEbyxwjKJ9Sy-1JAUwL h1 {\n    font-size: 24px;\n    font-family: Helvetica serif;\n    padding: 0 8px;\n    margin: 0;\n    color: white;\n  }\n  ._3IlFEbyxwjKJ9Sy-1JAUwL p {\n    font-size: 18px;\n    font-family: Helvetica serif;\n    padding: 0;\n    margin: 0;\n  }\n", ""]);
// Exports
exports.locals = {
	"formattedText": "_3IlFEbyxwjKJ9Sy-1JAUwL"
};
module.exports = exports;
